import React, { useContext } from 'react';

import { Context } from '@store/store';
import SpeechIconMobile from '@icons/speech-icon-mobile';
import SpeechIconDesktop from '@icons/speech-icon-desktop';

import { StyledSpeechButton } from './speech-button.styles';

const ShowSpeechDropdownButton = ({ isMobile }) => {
  const [state, dispatch] = useContext(Context);
  return (
    <React.Fragment>
      <StyledSpeechButton
        onClick={() => dispatch({ type: 'TOGGLE_SPEECH_DROPDOWN' })}
        isOpen={state.isSpeechDropdownOpened}
        isPlaying={state.speechState == 'PLAYING'}
        data-ignore-click-outside="dropdown"
        title="Озвучка текста"
      >
        {isMobile ? (
          <SpeechIconMobile
            width={18}
            height={18}
          />
        ) : (
          <SpeechIconDesktop
            width={13}
            height={25}
          />
        )}
      </StyledSpeechButton>
    </React.Fragment>
  );
};

export default ShowSpeechDropdownButton;
